import { StyleSheet, Dimensions } from 'react-native';
import { DeviceInfo } from 'qunar-react-native';
const { isAndroid } = DeviceInfo;
const { width } = Dimensions.get('window');
// 卡片宽度比例
const cardWidthScale = 94 / 375;

export default StyleSheet.create({
    memberCardLine: {
        height: 1,
        marginLeft: 16,
        marginRight: 16,
        position: 'absolute',
        top: 0,
        left: -20,
        width: '100%'
    },
    memberCard: {
        paddingBottom: 6,
        paddingHorizontal: 6,
        marginLeft: 16,
        marginRight: 16,
        borderRadius: 8,
        //opacity: 'rgba(0, 0, 0, 0.5)',
        marginBottom: 10
    },
    memberCardTop: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 4,
        paddingTop: 10,
        paddingBottom: 6,
        //backgroundColor: 'red'
    },
    memberCardIcon: {
        width: 102,
        height: 16
    },
    memberCardDesc: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    memberCardText: {
        fontSize: 11,
        paddingRight: 4
    },
    arrow: {
        fontSize: 13,
        color: '#56427D'
    },
    memberCardBottom: {
        flexDirection: 'row',
        alignItems: 'center',
        //backgroundColor: 'red',
        paddingVertical: 4,
        //justifyContent: 'flex-start'
        //display: 'none'
    },
    memberCardRightsShadow: {
        shadowOpacity: 0.1,
        shadowColor: '#000000',
        shadowRadius: 2,
        //shadowOffset: { width: 0, height: 2 },
        borderRadius: 8,
        marginLeft: 4,
        marginRight: 4
        //marginTop: 10
    },
    memberCardRights: {
        backgroundColor: '#FFFFFF',
        paddingVertical: 10,
        paddingHorizontal: 10,
        justifyContent: 'center',
        borderRadius: 8,
        alignItems: 'center',
        width: width * cardWidthScale
    },
    rightsText: {
        fontSize: 14,
        fontWeight: isAndroid ? 'bold' : '500',
        marginTop: isAndroid ? 0 : 5
    },
    rightsPriceView: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-around',
        marginTop: isAndroid ? 5 : 9,
        marginBottom: isAndroid ? 9 : 11
    },
    rightsPriceLeft: {
        fontSize: 11,
        marginRight: 4
    },
    rightsPriceRight: {
        fontSize: 9,
        color: '#999999',
        textDecorationLine: 'line-through'
    },
    buttonText: {
        fontSize: 13,
        fontWeight: isAndroid ? 'bold' : '500',
        marginBottom: isAndroid ? 1 : 0
    },
    memberCardRightsOnce: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingVertical: 12,
        paddingHorizontal: 16,
        //width: '100%'
    },
    rightsTextOnce: {
        fontSize: 16,
        fontWeight: isAndroid ? 'bold' : '500',
        marginTop: isAndroid ? 0 : 3,
       // lineHeight: 22
    },
    rightsPriceViewOnce: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-around',
        marginTop: isAndroid ? 5 : 9
    },
    rightsPriceLeftOnce: {
        fontSize: 12,
        marginRight: 4
    },
    rightsPriceRightOnce: {
        fontSize: 12,
        color: '#999999',
        textDecorationLine: 'line-through'
    },
});
